import React from 'react'
import { Search, X } from 'react-feather'

interface ComponentProps {
  searchTerm: string;
  handler: (text: string) => void;
  activeSearch?: boolean;
  handleActiveSearch?: () => void;
  placeholder: string;
  requireSubmit?: boolean;
  submitSearch?: (name: string) => void;
}

const SearchComponent: React.FC<ComponentProps>  = ({searchTerm, handler, activeSearch, handleActiveSearch, requireSubmit, placeholder, submitSearch}) => {

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  };

  return (
    <div className='rounded-xl flex flex-row items-center m-2 w-full bg-dark-input border border-dark-border px-3 py-1.5'>
      <Search size={18} className='text-gray-400'/>
      <form className='flex-1 mx-2' onSubmit={handleSubmit}>
        <input
          value={searchTerm}
          onChange={(e) => {handler(e.target.value)}}
          className='text-sm w-full bg-transparent text-white placeholder-gray-500 focus:outline-none'
          placeholder={placeholder}/>
      </form>
      {
        activeSearch
          ? <X size={18} className='text-gray-400 hover:text-white cursor-pointer'/>
          : null
      }
    </div>
  )
}

export default SearchComponent
